<div class="policy-list container-fluid">
  <h1 class="h3 mb-3">Policies</h1>

  <ul class="nav nav-tabs mb-3">
    <li class="nav-item" *ngFor="let f of families">
      <a class="nav-link" [routerLink]="['/policies', f.key]" routerLinkActive="active">{{ f.label }}</a>
    </li>
  </ul>

  <form class="row g-2 align-items-center mb-3" (submit)="$event.preventDefault()">
    <div class="col-auto">
      <input
        type="search"
        class="form-control"
        placeholder="Search by name or code"
        [ngModel]="search"
        (ngModelChange)="onSearchInput($event)"
        name="search"
      />
    </div>
    <div class="col-auto">
      <select class="form-select" [(ngModel)]="status" (ngModelChange)="onFilterChange()" name="status">
        <option value="">All statuses</option>
        <option value="active">Active</option>
        <option value="inactive">Inactive</option>
        <option value="draftOnly">Draft only</option>
      </select>
    </div>
    <div class="col-auto">
      <div class="form-check">
        <input
          type="checkbox"
          class="form-check-input"
          id="hasDraftFilter"
          [(ngModel)]="hasDraft"
          (ngModelChange)="onFilterChange()"
          name="hasDraft"
        />
        <label class="form-check-label" for="hasDraftFilter">Has draft</label>
      </div>
    </div>
  </form>

  <app-loading *ngIf="loading" [overlay]="false" size="small" message="Loading policies…"></app-loading>

  <div class="alert alert-danger d-flex justify-content-between align-items-center" *ngIf="errorMessage">
    <span>{{ errorMessage }}</span>
    <button type="button" class="btn btn-outline-danger btn-sm" (click)="retry()">Retry</button>
  </div>

  <ng-container *ngIf="!loading && !errorMessage">
    <table class="table table-hover align-middle" *ngIf="items.length; else emptyState">
      <thead>
        <tr>
          <th>Name</th>
          <th>Code</th>
          <th>Status</th>
          <th>Version</th>
          <th>Draft</th>
          <th>Assignments</th>
          <th>Last modified</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of items" role="button" (click)="goToDetail(item)">
          <td>{{ item.name }}</td>
          <td><code class="master-id-link">{{ item.masterId }}</code></td>
          <td><span class="badge" [ngClass]="statusBadgeClass(item.status)">{{ item.status }}</span></td>
          <td>{{ item.version ?? '—' }}</td>
          <td>
            <span class="badge text-bg-info" *ngIf="item.hasDraft">Draft</span>
            <span *ngIf="!item.hasDraft">—</span>
          </td>
          <td>{{ item.assignmentCount }}</td>
          <td>
            <ng-container *ngIf="item.modifiedAt; else noModified">
              {{ item.modifiedBy?.name ?? 'Unknown' }} · {{ item.modifiedAt | date: 'dd-MM-yyyy' }}
            </ng-container>
            <ng-template #noModified>—</ng-template>
          </td>
        </tr>
      </tbody>
    </table>
    <ng-template #emptyState>
      <div class="text-center text-muted py-5">No policies match these filters.</div>
    </ng-template>

    <nav aria-label="Policy list pagination" *ngIf="page > 1 || hasNextPage">
      <ul class="pagination">
        <li class="page-item" [class.disabled]="page === 1">
          <button type="button" class="page-link" [disabled]="page === 1" (click)="onPageChange(page - 1)">
            Previous
          </button>
        </li>
        <li class="page-item active"><span class="page-link">{{ page }}</span></li>
        <li class="page-item" [class.disabled]="!hasNextPage">
          <button type="button" class="page-link" [disabled]="!hasNextPage" (click)="onPageChange(page + 1)">
            Next
          </button>
        </li>
      </ul>
    </nav>
  </ng-container>
</div>
